// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-modal {
  border-radius: 26px;
  height: 100%;
  position: relative;
  overflow: auto;
  background: #F6F1EF;
}
@media (max-width: 992px) {
  .wrapper-modal {
    margin-top: 25px;
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}
.wrapper-modal ion-item {
  --background: #F6F1EF;
}
.wrapper-modal .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.wrapper-modal .close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper-modal .close-icon:hover {
  background: #f2dbd9;
}
.wrapper-modal .title-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFontBold, sans-serif;
  padding-top: 25px;
}
@media (min-width: 991px) {
  .wrapper-modal .title-text {
    font-size: 32px;
  }
}
.wrapper-modal .subtitle-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  padding: 10px;
}
@media (min-width: 991px) {
  .wrapper-modal .subtitle-text {
    font-size: 20px;
  }
}
.wrapper-modal .header-block {
  padding: 20px;
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    padding: 40px;
  }
}

.loading {
  height: 50vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/my-orders-modal/my-orders-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAIA;EAOI,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AATJ;ACCE;EDHF;IAEI,gBAAA;IACA,mBAAA;IACA,8BAAA;IACA,+BAAA;EAIF;AACF;AAEI;EACE,qBAAA;AAAN;AAEI;EAEE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AADN;AAEM;EACI,WAAA;EACA,YAAA;EACA,WAAA;AAAV;AAEM;EACI,mBAAA;AAAV;AAGI;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,iBAAA;AADN;AC3CE;EDsCE;IAQI,eAAA;EACN;AACF;AACI;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;EACA,aAAA;AACN;ACxDE;EDiDE;IAQI,eAAA;EAGN;AACF;AADI;EACI,aAAA;AAGR;AChEE;ED4DE;IAGQ,aAAA;EAKV;AACF;;AAFA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAKF","sourcesContent":["@import '../../../theme/mixins';\n\n\n\n.wrapper-modal {\n  @include mobile {\n    margin-top: 25px;\n    border-bottom: none;\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n    border-radius: 26px;\n    height: 100%;\n    position: relative;\n    overflow: auto;\n    background: #F6F1EF;\n    ion-item {\n      --background: #F6F1EF;\n    }\n    .close-icon {\n\n      position: absolute;\n      top: 15px;\n      right: 15px;\n      margin: 0px;\n      background: var(--color-white-accent);\n      width: 35px;\n      height: 35px;\n      padding: 0px;\n      z-index: 99;\n      ion-icon {\n          width: 100%;\n          height: 100%;\n          margin: 0px;\n      }\n      &:hover {\n          background: #f2dbd9;\n      }\n}\n    .title-text {\n      width: 100%;\n      text-align: center;\n      color: var(--color-black);\n      text-transform: uppercase;\n      font-family: AppFontBold, sans-serif;\n      padding-top: 25px;\n      @include desktop {\n        font-size: 32px;\n      }\n    }\n    .subtitle-text {\n      width: 100%;\n      text-align: center;\n      color: var(--color-black);\n      text-transform: uppercase;\n      font-family: AppFont, sans-serif;\n      padding: 10px;\n      @include desktop {\n        font-size: 20px;\n      }\n    }\n    .header-block {\n        padding: 20px;\n        @include desktop {\n            padding: 40px;\n        }\n    }\n}\n.loading {\n  height: 50vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
